import {
  AppstoreAddOutlined,
  CodeSandboxOutlined,
  FileDoneOutlined,
  PaperClipOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Col, Row } from 'antd';
import React from 'react';
import { useLocation, withRouter } from 'react-router-dom';
import {
  useAbilityContext,
  useAuthContext,
  useCustomerContext,
} from '../../context';
import { isBatEmployee } from '../../utils/roles';
import CartBadge from './CartBadge';
import TasksBadge from './TasksBadge';
import NavItem from './NavItem';

const BottomNav = () => {
  const { authUser } = useAuthContext();
  const ability = useAbilityContext();
  const location = useLocation();
  const { customer } = useCustomerContext();

  if (location?.pathname.endsWith('sign-in') || isBatEmployee(authUser))
    return null;
  return (
    <div
      className="hide-element-on-keyboard bottom-nav"
      style={{
        background: '#fff',
        position: 'fixed',
        overflow: 'hidden',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 100,
        width: '100%',
        lineHeight: 1.1,
        height: 'calc(60px + env(safe-area-inset-bottom))',
        paddingTop: '8px',
        paddingBottom: `calc(env(safe-area-inset-bottom) + 4px)`,
        borderTop: '1px solid hsla(0,0%,53.3%,.4)',
      }}
    >
      <Row style={{ justifyContent: 'space-evenly' }}>
        {!customer && (!authUser || authUser.role !== 'manager') && (
          <Col style={{ textAlign: 'center', marginLeft: '4px' }} span={4}>
            <NavItem to={'/customers'} label={'Kupci'}>
              <TeamOutlined style={{ fontSize: '22px' }} />
            </NavItem>
          </Col>
        )}
        {authUser && customer && (
          <Col style={{ textAlign: 'center', marginLeft: '4px' }} span={4}>
            <NavItem to={'/customer-action'} label={'Akcije'}>
              <AppstoreAddOutlined style={{ fontSize: '22px' }} />
            </NavItem>
          </Col>
        )}
        {(!authUser || authUser.role !== 'manager') && (
          <Col style={{ textAlign: 'center' }} span={5}>
            <NavItem to={'/products'} label={'Artikli'}>
              <CodeSandboxOutlined style={{ fontSize: '22px' }} />
            </NavItem>
          </Col>
        )}
        <Col style={{ textAlign: 'center' }} span={5}>
          <CartBadge>
            <NavItem to={'/cart'} label={'Korpa'}>
              <ShoppingCartOutlined style={{ fontSize: '22px' }} />
            </NavItem>
          </CartBadge>
        </Col>
        {authUser && ability.can('view', 'tasks') && (
          <Col style={{ textAlign: 'center' }} span={5}>
            <TasksBadge>
              <NavItem to={'/tasks'} label={'Zadaci'}>
                <FileDoneOutlined style={{ fontSize: '22px' }} />
              </NavItem>
            </TasksBadge>
          </Col>
        )}

        {authUser && ability.can('view', 'reports') && (
          <Col style={{ textAlign: 'center' }} span={4}>
            <NavItem to={'/reports'} label={'Izvještaji'}>
              <PaperClipOutlined style={{ fontSize: '22px' }} />
            </NavItem>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default withRouter(BottomNav);
